import * as React from "react";
import {observable} from "mobx";
import {CrudForm} from "../crud/CrudForm";
import {Input} from "../form/fields/Input";
import {Field} from "../form/Field";
import {PageContent} from "../Layout";
import {Button, Col, Row} from "reactstrap";
import {api} from "../../api";
import {IWindow} from "../../index";
import {enums} from "../../Enums";
import _ = require("lodash");

const IWindow: IWindow = (window as IWindow);

export class CollationResultDetailFormData {
    @observable id = IWindow.initialState.route.params.id;
    @observable number_of_votes = null;
    @observable candidate_name = null;
    @observable position = null;
    @observable election_name = null;
    @observable collation_type = null;
    @observable collation = null;
    @observable party_name = null;
    @observable state_name = null;
    @observable ward_name = null;
    @observable lga_name = null;
    @observable created_by = null;
    @observable created_at = null;
    @observable result_updated = null;
    @observable documents = null;
    @observable showDocuments = null;
    @observable check_lists = null;
}

export class CollationResultDetailForm extends CrudForm {
    modelName = 'CollationResultDetail';
    icon = '';

    getData = async () => {
        await api.collationResult.getDetailAction(this.formStore.getValue('id')).then((data: any) => {
            this.formStore.setValue('candidate_name', data.data.candidate.name);
            this.formStore.setValue('position', data.data.candidate.position.name);
            this.formStore.setValue('election_name', data.data.election.name);
            this.formStore.setValue('party_name', data.data.party);
            this.formStore.setValue('state_name', data.data.state);
            this.formStore.setValue('number_of_votes', data.data.number_of_votes);
            this.formStore.setValue('collation', data.data.collation);
            this.formStore.setValue('collation_type', data.data.collation_type);
            this.formStore.setValue('lga_name', data.data.lga);
            this.formStore.setValue('created_by', data.data.created_user.name);
            this.formStore.setValue('documents', data.data.documents);
            this.formStore.setValue('check_lists', data.data.check_lists);
            this.entity = data.data;
        });
        this.isLoading = false;
    };

    updateResult = async () => {
        await api.collationResult.postFormAction(this.formStore.getValue('id'), {
            'number_of_votes': this.formStore.getValue('number_of_votes')
        }).then((data: any) => {
            this.formStore.setValue('result_updated', data);
        });
        this.isLoading = false;
    };

    renderDocument(document: any) {
        switch (document.file_type) {
            case 'image':
                this.icon = 'icon-image';
                break;

            case 'document':
                this.icon = 'icon-pdf';
                break;

            case 'audio':
                this.icon = 'icon-speaker';
                break;

            case 'video':
                this.icon = 'icon-play-button';
                break;
        }

        return (
            <div className="form-group" key={document.id}>
                <a href={document.url} target='_blank'>
                    <span className={this.icon} /> {document.title}
                </a>
            </div>
        );
    }

    renderContent(item: any) {

        if (item.sub_type == 'entry') {
            return '';
        } else if (item.sub_type == 'other') {
            return item.remarks;
        } else if (item.sub_type == 'yes_no') {
            return <div>
                {item.yes_no ? "Yes" : "No"}
                <div>{item.remarks}</div>
            </div>;
        } else if (item.sub_type == 'yes_no') {
            return <div>
                {item.yes_no ? "Yes" : "No"}
                <div>{item.remarks}</div>
            </div>;
        } else if (item.sub_type == 'audio' || item.sub_type == 'document' || item.sub_type == 'video' || item.sub_type == 'image') {
            let document = _.findLast(this.formStore.getValue('documents'), ['check_list_id', item.check_list_id]) || null;
            if (document && document.url) {
                return <a href={document.url} download>Download</a>
            }
            return "";
        }

        return "";
    };

    renderCheckList(item:any) {
        return (
            <tr key={item.id}>
                <td>{item.title}</td>
                <td>{enums.checkListSubType[item.sub_type]}</td>
                <td><span
                    className={"ml-auto " + (item.is_completed ? 'icon-tick' : 'icon-close')}/></td>
                <td>
                    {this.renderContent(item)}
                </td>
            </tr>
        );
    }

    renderFields() {
        return (
            <>
                {
                    this.formStore.getValue('result_updated')?
                        <Row className="form-row">
                            <Col md={12}>
                                <div className="alert alert-success alert-dismissible fade show" role="alert">
                                    <button type="button" className="close" data-dismiss="alert" aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                    Result updated successfully!
                                </div>
                            </Col>
                        </Row> : ''
                }

                <Row className="form-row">
                    <Col md={6}>
                        <label className={'font-weight-bold text-primary'}>{ this.formStore.getValue('collation') + ' Votes'}</label>
                    </Col>
                    <Col md={6} className={'d-flex'}>
                        <Field
                            name="number_of_votes"
                            component={Input}
                            required={true}
                            placeholder="Number of Votes"
                            store={this.formStore}
                        />
                        <Button onClick={this.updateResult} type="button" color="primary" className={'mb-3 ml-2'}>
                            Save
                        </Button>
                    </Col>
                </Row>

                <Row className="form-row">
                    <Col md={6}>
                        <Row className="form-row">
                            <Col md={12}>
                                <div className={'form-group'}>
                                    <div className={'font-weight-bold'}>Candidate Name</div>
                                    <div className={'text-primary'}>{this.formStore.getValue('candidate_name')}</div>
                                </div>
                            </Col>
                        </Row>

                        <Row className="form-row">
                            <Col md={12}>
                                <div className={'form-group'}>
                                    <div className={'font-weight-bold'}>Position</div>
                                    <div className={'text-primary'}>{this.formStore.getValue('position')}</div>
                                </div>
                            </Col>
                        </Row>

                        <Row className="form-row">
                            <Col md={12}>
                                <div className={'form-group'}>
                                    <div className={'font-weight-bold'}>Elections</div>
                                    <div className={'text-primary'}>{this.formStore.getValue('election_name')}</div>
                                </div>
                            </Col>
                        </Row>

                        <Row className="form-row">
                            <Col md={12}>
                                <div className={'form-group'}>
                                    <div className={'font-weight-bold'}>Party</div>
                                    <div className={'text-primary'}>{this.formStore.getValue('party_name')}</div>
                                </div>
                            </Col>
                        </Row>
                        {this.formStore.getValue('collation_type') ?
                            <Row className="form-row">
                                <Col md={12}>
                                    <div className={'form-group'}>
                                        <div
                                            className={'font-weight-bold'}>{enums.userLevel[this.formStore.getValue('collation_type')]}</div>
                                        <div className={'text-primary'}>{this.formStore.getValue('collation')}</div>
                                    </div>
                                </Col>
                            </Row>
                            :''
                        }
                        {
                            this.formStore.getValue('lga_name')  ?
                        <Row className="form-row">
                            <Col md={12}>
                                <div className={'form-group'}>
                                    <div className={'font-weight-bold'}>LGA</div>
                                    <div className={'text-primary'}>{this.formStore.getValue('lga_name')}</div>
                                </div>
                            </Col>
                        </Row> : ''
                        }

                        <Row className="form-row">
                            <Col md={12}>
                                <div className={'form-group'}>
                                    <div className={'font-weight-bold'}>State</div>
                                    <div className={'text-primary'}>{this.formStore.getValue('state_name')}</div>
                                </div>
                            </Col>
                        </Row>

                        <Row className="form-row">
                            <Col md={6}>
                                <div className={'form-group'}>
                                    <div className={'font-weight-bold'}>Registered Voters</div>
                                    <div className={'text-primary'}>{this.formStore.getValue('number_of_votes')}</div>
                                </div>
                            </Col>
                        </Row>

                        <Row className="form-row">
                            <Col md={12}>
                                <div className={'form-group'}>
                                    <div className={'font-weight-bold'}>Uploaded by</div>
                                    <div className={'text-primary'}>{this.formStore.getValue('created_by')}</div>
                                    <div>{this.formStore.getValue('created_at')}</div>
                                </div>
                            </Col>
                        </Row>
                    </Col>

                    <Col md={6}>
                        <div className={'font-weight-bold form-group'}>Uploaded files</div>
                        { this.formStore.getValue('documents') ?
                            this.formStore.getValue('documents').map((document: any) => {
                                return this.renderDocument(document);
                            })
                            : ''

                        }
                    </Col>
                </Row>

                {this.formStore.getValue('check_lists')? <br/> : '' }
                {this.formStore.getValue('check_lists') ?
                    <div className="d-flex flex-column">
                        <div className="card dashboard-card box-shadow border-0 rounded-0 flex-grow-1">
                            <div className="card-body py-0 d-flex flex-column">
                                <div className="row">
                                    <div className="col-xl-12 dash-sep-xl-right">
                                        <h6 className="light-subheading text-center text-uppercase my-3">Check Lists</h6>
                                        <div className="table-responsive">
                                            <table className="grid table table-hover">
                                                <thead>
                                                <tr>
                                                    <th>Title</th>
                                                    <th>Type</th>
                                                    <th>Is Completed</th>
                                                    <th>Content</th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                {
                                                    this.formStore.getValue('check_lists').map((checkList: any) => {
                                                        return this.renderCheckList(checkList);
                                                    })
                                                }
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div> : ''}
            </>
        );
    }
}

export class CollationResultDetailPage extends React.Component {
    modelName = 'CollationResultDetail';

    constructor(props: any) {
        super(props);
    }

    render() {
        return (
            <>
                <PageContent>
                    <CollationResultDetailForm />
                </PageContent>
            </>
        );
    }
}



// WEBPACK FOOTER //
// ./resources/js/components/pages/CollationResultDetailPage.tsx